module.exports = __webpack_public_path__ + "934516785cf722024918478fbca2bd4c.fbx";